module.exports = __webpack_public_path__ + "static/dash-3ad4e1486f6700e5d94d838a8234be3d.webm";